import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { getStageScreen, setLoading } from "../../../../redux";
import Button from "../../components/Button";
import Title from "../../components/Title";
import {
  CONSORTIUM_API_URL,
  MARFATIA_API_URL,
  VACHANA_API_URL,
  showPrevBtnByUrl,
  showNextBtnByUrl,
  getPrevAndNextRoute,
} from "utils";
import Consortium from "./component/Consortium";

const BrokerageScheme = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { loading } = useSelector((state) => state.common);
  const { kycStatus, kycPageName } = useSelector((state) => state.navigation);
  const [schemaOptions, setSchemaOptions] = useState({
    disabled: false,
    items: [],
  });
  const [selectedOption, setSelectedOption] = useState("");
  const [schemaCharges, setSchemaCharges] = useState([]);
  const [bsStruture, setBsStruture] = useState("");

  const getApiUrl = () => {
    const portal_domain = window.sessionStorage.getItem("portal_domain");
    let API_URL = "";
    if (portal_domain) {
      API_URL = portal_domain.substring(0, portal_domain.length - 1);
    }
    return API_URL;
  };

  const getApiHeader = () => {
    const token = window.sessionStorage.getItem("token");
    let headers = "";
    if (token) {
      headers = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          Authorization: `Basic ${token}`,
        },
      };
    }
    return headers;
  };

  const loadSchemaDetail = useCallback(async () => {
    dispatch(setLoading(true));
    try {
      const resp = await axios.get(
        `${getApiUrl()}/api/method/kyc_customizations.apis.brokerage_scheme_tariff_charges.api.get_brokerage_scheme_details`,
        getApiHeader()
      );
      // if(getApiUrl() === "https://scmcbrke.in"){
      //   setSelectedOption(resp.data?.data?.default ?? "");
      // }
      if (resp.data?.data?.only_default_brokerage_scheme) {
        setSelectedOption(resp.data?.data?.default ?? "");
        setSchemaOptions({
          disabled: true,
          items: [],
        });
      }
      if (resp.data?.data?.new_bs_struture) {
        setSchemaOptions((prev) => {
          return { ...prev, items: resp.data?.message?.slice(0, 1) || [] };
        });
        setSchemaCharges(
          (resp.data?.data?.charges || []).map((item) => ({
            ...item,
            selection: "Both side",
          }))
        );
        setBsStruture(resp.data?.data?.new_bs_struture);
      } else {
        const dataList = resp.data?.message || [];
        setSchemaOptions((prev) => {
          return {
            ...prev,
            items:
              getApiUrl() === MARFATIA_API_URL
                ? dataList.slice(0, 3)
                : dataList,
          };
        });
      }
      dispatch(setLoading(false));
    } catch {
      dispatch(setLoading(false));
    }
  }, [dispatch]);

  useEffect(() => {
    loadSchemaDetail();
  }, [loadSchemaDetail]);

  // on select loadBrokerageScheme
  const loadBrokerageScheme = useCallback(async () => {
    if (!selectedOption) return;
    dispatch(setLoading(true));
    try {
      const resp = await axios.post(
        `${getApiUrl()}/api/method/kyc_customizations.apis.brokerage_scheme_tariff_charges.api.get_brokerage_scheme`,
        { name: selectedOption },
        getApiHeader()
      );
      dispatch(setLoading(false));
      if (resp.data?.data?.new_bs_struture) {
        setSchemaCharges(
          (resp.data?.data?.charges || []).map((item) => ({
            ...item,
            selection: "Both side",
          }))
        );
        setBsStruture(resp.data?.data?.new_bs_struture);
      } else {
        setSchemaCharges(resp.data?.data?.charges || []);
      }
    } catch {
      dispatch(setLoading(false));
    }
  }, [dispatch, selectedOption]);

  useEffect(() => {
    loadBrokerageScheme();
  }, [loadBrokerageScheme]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    dispatch(setLoading(true));
    const payload = {
      brokerage_scheme: selectedOption,
    };
    if (bsStruture) {
      payload["new_brokerage_scheme_struture"] = schemaCharges;
      payload["new_bs_structure"] = bsStruture;
    }
    try {
      await axios.post(
        `${getApiUrl()}/api/method/kyc_customizations.apis.brokerage_scheme_tariff_charges.api.update_brokerage_scheme_details`,
        payload,
        getApiHeader()
      );
      toast.success("Brokerage Scheme saved successfully.");
      dispatch(getStageScreen());
      dispatch(setLoading(false));
    } catch (error) {
      const { response } = error;
      dispatch(setLoading(false));
      toast.error(response?.data?.message || "Internal server error!");
    }
  };
  return (
    <div>
      <Title title="Brokerage Scheme Charges" />
      {!loading && (
        <>
          {getApiUrl() != CONSORTIUM_API_URL ? (
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-7">
                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      <div className="mb-2">
                        <select
                          className="form-select"
                          value={selectedOption}
                          onChange={({ target }) =>
                            setSelectedOption(target.value)
                          }
                          disabled={schemaOptions.disabled}
                        >
                          <option
                            value=""
                            selected
                            disabled
                          >
                            {getApiUrl() === "https://scmcbrkc.in"
                              ? "Please select an account maintenance"
                              : "Please select an option"}
                          </option>
                          {schemaOptions.items.map((item, index) => {
                            return (
                              <option
                                value={item}
                                key={index}
                              >
                                {item}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      {getApiUrl() === VACHANA_API_URL && (
                        <div className="mt-2">
                          <a
                            href="https://onedrive.live.com/?authkey=%21AGWkJO448Y4UPdA&id=1BF3E657C433B9FD%2152167&cid=1BF3E657C433B9FD&parId=root&parQt=sharedby&o=OneUp"
                            target="_blank"
                            rel="noreferrer"
                            className="text-primary"
                          >
                            Tariff Details
                          </a>
                        </div>
                      )}
                      <div className="d-flex mt-4">
                        {showPrevBtnByUrl(
                          history.location.pathname,
                          kycStatus,
                          kycPageName
                        ) && (
                          <Button
                            title="Previous"
                            type="button"
                            className="mx-1"
                            handleClick={() => {
                              const route = getPrevAndNextRoute(
                                history.location.pathname.slice(1),
                                kycPageName
                              );
                              history.push(route.prev);
                            }}
                          />
                        )}
                        <Button
                          title="Submit"
                          className="mx-1"
                          disabled={!selectedOption}
                        />
                        {showNextBtnByUrl(
                          history.location.pathname,
                          kycStatus,
                          kycPageName
                        ) && (
                          <Button
                            title="Next"
                            type="button"
                            className="mx-1"
                            handleClick={() => {
                              const route = getPrevAndNextRoute(
                                history.location.pathname.slice(1),
                                kycPageName
                              );
                              history.push(route.next);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-md-12">
                  {schemaCharges.length > 0 && (
                    <div>
                      <h3>
                        Tariff Sheet (Charges Applicable on Trading
                        Transactions)
                      </h3>
                      {bsStruture === 1 ? (
                        <div className="row">
                          {schemaCharges.map((item, index) => (
                            <div
                              className="col-md-4 p-0"
                              key={index}
                            >
                              <table className="table">
                                <tbody>
                                  <tr>
                                    <th
                                      colSpan="4"
                                      className="text-center"
                                    >
                                      {item.segment}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th></th>
                                    <th className="text-center">Min</th>
                                    <th className="text-center">%</th>
                                    <th></th>
                                  </tr>
                                  <tr>
                                    <td>{item.first_label}</td>
                                    <td>{item.first_min}</td>
                                    <td>{item.first_min_}</td>
                                    <td>
                                      {/* <p>
                                    <input type="checkbox" /> One Side
                                  </p> */}
                                      <p>
                                        <input
                                          type="checkbox"
                                          checked={
                                            item.selection === "Both side"
                                          }
                                          disabled
                                        />{" "}
                                        {item.selection}
                                      </p>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>{item.sec_label}</td>
                                    <td>{item.sec_min}</td>
                                    <td>{item.sec_min_}</td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <table className="table">
                          <thead>
                            <tr>
                              <th>Tariff Type</th>
                              <th>Charges</th>
                            </tr>
                          </thead>
                          <tbody>
                            {schemaCharges.map((item, index) => (
                              <tr key={index}>
                                <td className="font-weight-bold">
                                  {item.tariff_type}
                                </td>
                                <td>{item.charges}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  )}
                  {getApiUrl() === "https://scmcbrkc.in" ? (
                    <table
                      className="table"
                      style={{ display: "none" }}
                    >
                      <thead>
                        <tr>
                          <th></th>
                          <th>Plan A</th>
                          <th>Plan B</th>
                          <th>Plan C</th>
                          <th>Plan D</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="font-weight-bold">
                            Account Maintenance
                          </td>
                          <td>
                            1. One Year Rs.300/- (For First Quarter remaining
                            Three Quarter FREE)
                          </td>
                          <td>
                            2. Five Year Rs.900/- (For First Quarter remaining
                            Nineteen Quarter FREE)
                          </td>
                          <td>3. Life Time Rs.1800/-</td>
                          <td>
                            4. Non-Individual Rs.900/- Per year (Applied F.Y.
                            Basis){" "}
                          </td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">
                            Dematerialisation Charges
                          </td>
                          <td
                            colSpan={4}
                            className="text-center"
                          >
                            Rs.70/-  Per Request
                          </td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">
                            Rematerialisation Charges
                          </td>
                          <td
                            colSpan={4}
                            className="text-center"
                          >
                            Rs.70/- Per Request
                          </td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">
                            Transaction (Debit)
                          </td>
                          <td
                            colSpan={4}
                            className="text-center"
                          >
                            POA On Market Rs.13/- Per Trade <br />
                            POA Off Market Rs.16/- Per Trade <br />
                            Non-POA All Trade Rs.26/- Per Trade <br />
                            Outside FIIPL Rs.26/- Per Trade
                          </td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Pledge Creation</td>
                          <td
                            colSpan={4}
                            className="text-center"
                          >
                            Rs.25/- Per Trade
                          </td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Pledge Closer</td>
                          <td
                            colSpan={4}
                            className="text-center"
                          >
                            Rs.25/- Per Trade
                          </td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Other Charge</td>
                          <td
                            colSpan={4}
                            className="text-center"
                          >
                            Demat Rejection/Modification Rs.40/- per instance
                            (Including Courier Charge).
                          </td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Remarks</td>
                          <td
                            colSpan={4}
                            className="text-left"
                          >
                            1. GST @18% will be charge on above mention DP
                            charges. <br />
                            2. On customer request or to fulfil regulatory
                            compliances if we need to dispatch physical
                            documents, courier charge of Rs.25/- will be
                            charged. <br />
                            3. Maintenance & KRA charges will be charged in
                            advance at the time of opening the account
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  ) : (
                    <>
                      <table
                        className="table"
                        style={{ display: "none" }}
                      >
                        {/* <thead>
                      <tr>
                        <th className="text-center" colSpan={2}>
                          VDD
                        </th>
                      </tr>
                    </thead> */}
                        <tbody>
                          <tr>
                            <th>Type of Tariff Charge</th>
                            <td>Amount(Excluding GST)</td>
                          </tr>
                          <tr>
                            <th>Stamp charges payable upfront</th>
                            <td>Rs. 100/-</td>
                          </tr>
                          <tr>
                            <th>Custody charges</th>
                            <td>NIL</td>
                          </tr>
                          <tr>
                            <th>
                              Annual Maintenance Charges : (Payable Upfront)
                            </th>
                            <td>-</td>
                          </tr>
                          <tr>
                            <th>Individual</th>
                            <td>Rs. 400/- + GST</td>
                          </tr>
                          <tr>
                            <th>Transaction Charges : (Market Trades)</th>
                            <td>-</td>
                          </tr>
                          <tr>
                            <th>Buy(Receive)</th>
                            <td>NIL</td>
                          </tr>
                          <tr>
                            <th>Sell(Debit)</th>
                            <td>
                              0.03% or Rs. 9/- whichever is higher + (CDSL
                              Charges)
                            </td>
                          </tr>
                          <tr>
                            <th>Transaction Charges : (Off- Market Trades)</th>
                            <td>0.03% or Rs. 25/- whichever is higher</td>
                          </tr>
                          <tr>
                            <th>Demat (Per certificate)</th>
                            <td>Rs. 7 /- + Rs. 70 as courier charges</td>
                          </tr>
                          <tr>
                            <th>Remat (Per ISIN)</th>
                            <td>
                              Rs. 15 + Rs. 10 for every 100 shares or part there
                              of or a flat fee of Rs. 10 per certificate
                              whichever is higher (CDSL Charges)
                            </td>
                          </tr>
                          <tr>
                            <th>Courier charges per Demat / Remat</th>
                            <td>Rs.70/-</td>
                          </tr>
                          <tr>
                            <th>Pledge Request</th>
                            <td>
                              Rs. 20/- + Rs. 12/- per request (CDSL Charges)
                            </td>
                          </tr>
                          <tr>
                            <th>Unpledge Request</th>
                            <td>
                              Rs. 20/- + Rs. 12/- per request (CDSL Charges)
                            </td>
                          </tr>
                          <tr>
                            <th>Pledge Invocation</th>
                            <td>Rs. 20/-</td>
                          </tr>
                          <tr>
                            <th>Periodic Statement</th>
                            <td>-</td>
                          </tr>
                          <tr>
                            <th>By Email</th>
                            <td>Free</td>
                          </tr>
                          <tr>
                            <th>Physical</th>
                            <td>Rs.2/- per sheet +Rs.70/-(Courier Charges)</td>
                          </tr>
                          <tr>
                            <th>Adhoc / Non Periodic Statement Requests</th>
                            <td>-</td>
                          </tr>
                          <tr>
                            <th>By Email</th>
                            <td>Rs. 50/- per request</td>
                          </tr>
                          <tr>
                            <th>Physical</th>
                            <td>
                              Rs. 50/- per request upto 10 pages. Every
                              additional page at Rs.5/- + Rs. 70/- (Courier)
                            </td>
                          </tr>
                          <tr>
                            <th>Delivery Instruction</th>
                            <td>-</td>
                          </tr>
                          <tr>
                            <th>First Delivery Instruction Book</th>
                            <td>Free (10 Leaves)</td>
                          </tr>
                          <tr>
                            <th>Every Additional Booklet (10 Leaves)</th>
                            <td>Rs. 100/- + Rs 70/- (Courier Charges)</td>
                          </tr>
                          <tr>
                            <th>Transfer through "easiest" (online)</th>
                            <td>Free</td>
                          </tr>
                          <tr>
                            <th>Cheque Bounce Charges</th>
                            <td>Rs. 350/-</td>
                          </tr>
                          <tr>
                            <th>Failed Transactions</th>
                            <td>Rs. 50/- per ISIN</td>
                          </tr>
                          <tr>
                            <th>Account Closure</th>
                            <td>NIL</td>
                          </tr>
                          <tr>
                            <th>Modification in CML</th>
                            <td>Rs. 25/- per request</td>
                          </tr>
                          <tr>
                            <th>KRA Upload /Download</th>
                            <td>Rs. 35/-</td>
                          </tr>
                        </tbody>
                      </table>
                      <div style={{ display: "none" }}>
                        <p>NOTE: </p>
                        <p>
                          For all purposes the bill date shall be construed as
                          the date of demand and the bills will be considered as
                          the bill cum Notice for payment and Vachana
                          Investments Pvt Ltd reserves the right to freeze
                          depository account for debit transactions in case of
                          non payment of charges after two days from the bill
                          date.
                        </p>
                        <p>
                          Interest@ 18% p.a will be charged on the outstanding
                          bill amount if not paid within the due date. The above
                          tariff is subject to change. Changes if any will be
                          intimated 30days in advance. Goods and Service Tax
                          (GST) or any other statutory levies will be applicable
                          on all on all above charges except stamp charges.
                        </p>
                      </div>

                      {/* <table className="table">
                    <thead>
                      <tr>
                        <th className="text-center" colSpan={2}>
                        VSD
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>Equity Cash-Delivery</th>
                        <td>0.03%</td>
                      </tr>
                      <tr>
                        <th>Equity Cash-Delivery</th>
                        <td>0.30%</td>
                      </tr>
                      <tr>
                        <th>F & O - Future</th>
                        <td>0.03%</td>
                      </tr>
                      <tr>
                        <th>F & O - Option</th>
                        <td>50Rs</td>
                      </tr>
                    </tbody>
                  </table>

                  <table className="table">
                    <thead>
                      <tr>
                        <th className="text-center" colSpan={2}>
                        VID
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>Equity Cash-Delivery</th>
                        <td>0.05%</td>
                      </tr>
                      <tr>
                        <th>Equity Cash-Delivery</th>
                        <td>0.50%</td>
                      </tr>
                      <tr>
                        <th>F & O - Future</th>
                        <td>0.50%</td>
                      </tr>
                      <tr>
                        <th>F & O - Option</th>
                        <td>75Rs</td>
                      </tr>
                    </tbody>
                  </table> */}

                      {/* <thead>
                    <tr>
                      <th></th>
                      <th></th>
                      <th>Scheme A</th>
                      <th>Scheme B</th>
                      <th>Scheme C</th>
                      <th>Scheme D</th>
                      <th>Scheme E</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="font-weight-bold">Stamp Charges</td>
                      <td></td>
                      <td>300/-</td>
                      <td>300/-</td>
                      <td>300/-</td>
                      <td>300/-</td>
                      <td>300/-</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Deposit</td>
                      <td></td>
                      <td>Nil</td>
                      <td>
                        Rs.2000/-Deposit would be taken as of relevant year in case of
                        closure of the account.
                      </td>
                      <td>
                        Rs 4000/- Deposit –Minimum Lockin period 2 Years (If close before
                        2 years, Year wise AMC applicable as per prorate)
                      </td>
                      <td>NIL</td>
                      <td>Rs. 900/- Non Refundable</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">AMCs</td>
                      <td></td>
                      <td>Rs. 350/-</td>
                      <td>Nil</td>
                      <td>Nil</td>
                      <td>Free</td>
                      <td>Nil</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">AMC for Corporate A/c.</td>
                      <td></td>
                      <td>Rs. 850/</td>
                      <td>N.A</td>
                      <td>N.A</td>
                      <td>N.A</td>
                      <td>N.A</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">
                        Transaction on Charges (Per ISIN)
                      </td>
                      <td>POA-Transaction on (on & EP)</td>
                      <td>Rs.12/-</td>
                      <td>Rs.15/-</td>
                      <td>Rs.12/-</td>
                      <td>Rs.25/-</td>
                      <td>Rs.17/-</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>Off market</td>
                      <td>
                        0.010 % of transaction value. Subject to minimum Rs. 15/- and
                        maximum Rs 25/-
                      </td>
                      <td>
                        0.010 % of transaction value. Subject to minimum Rs. 15/- and
                        maximum Rs 25/-
                      </td>
                      <td>
                        0.010 % of transaction value. Subject to minimum Rs. 15/- and
                        maximum Rs 25/-
                      </td>
                      <td>Rs.25/-</td>
                      <td>
                        0.010 % of transaction value.Subject to minimum Rs.17/- and
                        maximum Rs25/
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>Inter DP</td>
                      <td>Rs.25/-</td>
                      <td>Rs.25/-</td>
                      <td>Rs.25/-</td>
                      <td>Rs.25/-</td>
                      <td>Rs.25/-</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Demat Charges (Per DRF)</td>
                      <td>Rs.75/-</td>
                      <td>Rs.75/-</td>
                      <td>Rs.75/-</td>
                      <td>Rs.75/-</td>
                      <td>Rs.75/-</td>
                      <td>Rs.75/-</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Remat Charges (Per RRF)</td>
                      <td></td>
                      <td>Rs 15/- + Courier Charges of Rs 35/-</td>
                      <td>Rs 15/- + Courier Charges of Rs 35/-</td>
                      <td>Rs 15/- + Courier Charges of Rs 35/-</td>
                      <td>Rs 15/- + Courier Charges of Rs 35/-</td>
                      <td>Rs 15/- + Courier Charges of Rs 35/-</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">
                        Pledge Services (Per ISIN) Creating/Closure/Invoke
                      </td>
                      <td></td>
                      <td>Rs 50/- Per Request</td>
                      <td>Rs 50/- Per Request</td>
                      <td>Rs 50/- Per Request</td>
                      <td>Rs 50/- Per Request</td>
                      <td>Rs 50/- Per Request</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">
                        Pay In Day Sell/Failed Instruction on (Per ISIN)
                      </td>
                      <td></td>
                      <td>Rs.10/-</td>
                      <td>Rs.10/-</td>
                      <td>Rs.10/-</td>
                      <td>Rs.10/-</td>
                      <td>Rs.10/-</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Modification on Charges</td>
                      <td></td>
                      <td>Rs 25/- (Address & Bank details change)</td>
                      <td>Rs 25/- (Address & Bank details change)</td>
                      <td>Rs 25/- (Address & Bank details change)</td>
                      <td>Rs 25/- (Address & Bank details change)</td>
                      <td>Rs 25/- (Address & Bank details change)</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Extra Statement Charges</td>
                      <td></td>
                      <td>Rs 15/ - Per statement</td>
                      <td>Rs 15/ - Per statement</td>
                      <td>Rs 15/ - Per statement</td>
                      <td>Rs 15/ - Per statement</td>
                      <td>Rs 15/ - Per statement</td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Margin Pledge</td>
                      <td></td>
                      <td>Rs 20/ -</td>
                      <td>Rs 20/ -</td>
                      <td>Rs 20/ -</td>
                      <td>Rs 25/ -</td>
                      <td>Rs 20/ -</td>
                    </tr>
                  </tbody> */}
                    </>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div>
              <Consortium />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default BrokerageScheme;
